import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { StorageService } from 'src/app/utils/storage/storage.service';
import { environment } from 'src/environments/environment';
import { ClientsService } from '../clients/clients.service';
import { finalize, forkJoin, map, Observable, Subject, takeUntil, tap } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ClientModulesService } from '../clients/info-client/client-modules/client-modules.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-aplication',
    templateUrl: './aplication.component.html',
    styleUrls: ['./aplication.component.scss'],
})
export class AplicationComponent implements OnInit, OnDestroy {
    private token: any = null;
    helper = helper;
    private unsubscribe$ = new Subject<void>();

    isLoading = false;

    clientsWithModules: any = [];

    constructor(
        private router: Router,
        private storageService: StorageService,
        private authService: AuthService,
        private clientsService: ClientsService,
        private clientModules: ClientModulesService
    ) { }

    ngOnInit(): void {
        const tokenStorage = this.storageService.getString(
            environment.config.tokenKey
        );
        tokenStorage.then((val) => {
            const isTokenExpired = this.authService.isTokenExpired(val);
            if (isTokenExpired || val == null) {
                this.router.navigate(['/pages/login']);
            } else {
                this.token = val;
                this.loadClientModules();
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    loadClientModules() {
        this.isLoading = true;
        this.clientModules.getUserClientModules()
            .pipe(
                takeUntil(this.unsubscribe$),
                map((results: any) => results.data),
                map((data: any) => {

                    const transformedArray = Object.values(data).map((clientData: any) => {
                        const modules = clientData.module
                            .map((module: { id: number, name: string, display_name: string, url_front_end: string | null, order: number }) => ({
                                id: module.id,
                                name: module.name,
                                display_name: module.display_name,
                                url_front_end: module.url_front_end,
                                order: module.order
                            }))
                            .sort((a: any, b: any) => a.order - b.order);

                        return {
                            id: clientData.client_id,
                            name: clientData.client_name,
                            display_name: clientData.client_display_name,
                            modules: modules
                        };
                    });
                    this.clientsWithModules = transformedArray;
                }),
                finalize(() => { this.isLoading = false; })
            )
            .subscribe();
    }

    navigateToRoute(urlFe: any, clientId: number, moduleId: number) {

        console.log(urlFe, clientId, moduleId, 'check here?')

        // remove 'if' and the 'switch' below after all the url_fe will be set in the client module. For the moment, only urbanism is using the short token logic
        if ([2, 3, 5, 8, 9, 6, 4, 10, 11].includes(moduleId)) { // 2 => urbanism, 3 => plati
            this.isLoading = true;
            if (environment.env == 'development' || environment.env == 'local') {
                if (moduleId == 2) urlFe = environment.interop.destinations.urbanismPath;
                if (moduleId == 3) urlFe = environment.interop.destinations.platiOperatorPath;
                if (moduleId == 5) urlFe = environment.interop.destinations.autorizariComercialeOperatorPath;
                if (moduleId == 9) urlFe = environment.interop.destinations.monitorizareOperatorPath;
                if (moduleId == 6) urlFe = environment.interop.destinations.indocOperatorPath;
                if (moduleId == 4) urlFe = environment.interop.destinations.dgitlOperatorPath;
                if (moduleId == 10) urlFe = environment.interop.destinations.depsOperatorPath;
                if (moduleId == 11) urlFe = environment.interop.destinations.dgaspcOperatorPath;
            }

            this.authService.generateShortToken(clientId, moduleId)
                .pipe(
                    finalize(() => { this.isLoading = false; }),
                    takeUntil(this.unsubscribe$)
                )
                .subscribe(
                    (response: any) => {
                        const shortToken = response.data;
                        const url = urlFe + '/#/token/' + shortToken;
                        window.location.href = url;
                        return false;
                    },
                    (err: any) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }

                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: msg,
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                            showCancelButton: false,
                            allowOutsideClick: false,
                        });

                        return false;
                    }
                );

            return false;
        }

        // this is a temporary logic which will be replace by the content of the 'if' above after all modules will be working with the short token.
        let link;
        switch (urlFe) {
            case 'urb-inurbanism':
                link =
                    environment.interop.destinations.urbanismPath +
                    '/#/token/' +
                    this.token;
                break;
            case 'dgitl-inpayments':
                link =
                    environment.interop.destinations.platiOperatorPath +
                    '/#/token/' +
                    this.token;
                break;
            case 'dgitl-indoc':
                link =
                    environment.interop.destinations.indocOperatorPath +
                    '/#/token/' +
                    this.token;
                break;
            case 'dgitl-inregistraturaonline':
                link =
                    environment.interop.destinations.dgitlOperatorPath +
                    '/#/token/' +
                    this.token;
                break;
            case 'ps4-indoc':
                link =
                    environment.interop.destinations.indocOperatorPath +
                    '/#/token/' +
                    this.token;
                break;
            case 'autorizatii-comerciale':
                link =
                    environment.interop.destinations.autorizariComercialeOperatorPath +
                    '/#/token/' +
                    this.token;
                break;
            default:
                return false;
        }
        window.location.href = link;
        return false;
    }

    navigateToTaxeImpozite() {
        window.location.href = 'https://www.taxeimpozite4.ro/';
    }

    getClientModuleClass(i: number, clientModulesNumber: any) {
        // last item full width
        if (i % 2 === 0 && i === clientModulesNumber - 1) {
            return 'w-100';
        }

        // only 2 modules, no margin bottom
        if (clientModulesNumber === 2) return 'col-md-6 multiple-modules-width';

        return 'mb-3 col-md-6 multiple-modules-width';
    }
}
